import { FC } from "react";

import Box from "../Box/Box";
import Typography from "../Typography/Typography";
import styled from "styled-components";
import {
  BackgroundColorProps,
  BorderColorProps,
  ColorProps,
} from "styled-system";

import TimelineBlock from "./TimelineBlock";
import { ItemProps } from "./HorizontalTimeline";

interface ItemBlockProps {
  index: number;
  minContainerWidth: number;
  item: ItemProps;
  numberOfItems: number;
  labelsColor: ColorProps["color"];
  labelsBackgroundColor: BackgroundColorProps["backgroundColor"];
  labelsBorderColor: BorderColorProps["borderColor"];
  connectorColor: BorderColorProps["borderColor"];
  titleColor: ColorProps["color"];
  descriptionColor: ColorProps["color"];
}

const ItemContainer = styled(Box)<{ minContainerWidth: number }>`
  ${(props) => `@media (min-width: ${props.minContainerWidth}px) {
    flex-direction: column;
    min-width: 250px;
  }`}
`;

const ItemBlock: FC<ItemBlockProps> = ({
  index,
  minContainerWidth,
  item,
  numberOfItems,
  labelsColor,
  labelsBackgroundColor,
  labelsBorderColor,
  connectorColor,
  titleColor,
  descriptionColor,
}) => (
  <ItemContainer
    width="auto"
    display="flex"
    flexDirection="row"
    maxWidth="400px"
    minWidth="278px"
    minContainerWidth={minContainerWidth}
    as="li"
  >
    <TimelineBlock
      index={index}
      minContainerWidth={minContainerWidth}
      item={item}
      numberOfItems={numberOfItems}
      labelsColor={labelsColor}
      labelsBackgroundColor={labelsBackgroundColor}
      labelsBorderColor={labelsBorderColor}
      connectorColor={connectorColor}
    />
    <Box px={{ _: 4, tablet: 6 }}>
      <Typography
        variant="h6"
        m={0}
        mb={3}
        textAlign="center"
        color={titleColor}
      >
        {item.title}
      </Typography>
      <Typography
        variant="body-small"
        m={0}
        textAlign="center"
        color={descriptionColor}
        pb={60}
      >
        {item.description}
      </Typography>
    </Box>
  </ItemContainer>
);

export default ItemBlock;
